/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { UserProfileSignatureBusinessService } from '../../resources';
import { UserProfileSignatureDialogComponent } from './user-profile-signature-dialog.component';

export const userProfileSignatureDialog = createDialogRoute({
  component: UserProfileSignatureDialogComponent,
  init: UserProfileSignatureBusinessService,
});
